import { Color, Icon, VerticalLineSVG } from '@bb/elements-web';
import React from 'react';
import styled from 'styled-components';

function UpcomingChangesIcons() {
  return (
    <IconCircle>
      <Icon icon="carryOutTwoTone" color="primary" size={24} />
      <VerticalLineSVG color={Color.PRIMARY} />
      <Icon icon="clockCircleOutlined" color="primary" size={24} />
    </IconCircle>
  );
}

export default UpcomingChangesIcons;

const IconCircle = styled.div`
  display: flex;
  height: 114px;
  padding: 5px 0 6px 0;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
